<template>
  <div class="cpfu">
    <div v-wechat-title="$route.meta.title" v-if="active == 0"></div>
    <div v-wechat-title="$route.meta.title2" v-if="active == 1"></div>
    <div v-wechat-title="$route.meta.title3" v-if="active == 2"></div>
    <div v-wechat-title="$route.meta.title4" v-if="active == 3"></div>

    <div class="dhtBox">
      <div class="cdBox">
        <div class="logo"></div>
        <div @click="shouye" class="cd">首页</div>
        <div @click="fuwu" class="cd bxz">产品服务</div>
        <div @click="sxy" class="cd">商学院</div>
        <div @click="cpgyl" class="cd">产品供应链</div>
        <div @click="hzal" class="cd">合作案例</div>
        <div @click="ydd(hsk)" class="cd yddapp">
          移动端
          <div class="yddxiazai" v-if="hsk == 2">
            <div class="hezi">
              <!-- <div class="img img1"></div> -->
              <!-- <div class="text">米商云</div> -->
            </div>
            <div class="hezi">
              <div class="img img2">
                <img
                  src="../../assets/images/9774f492e19d7134dca0552612911f5.jpg"
                  alt=""
                />
              </div>
              <div class="text">米小礼</div>
            </div>
            <div class="hezi">
              <!-- <div class="img img3"></div> -->
              <!-- <div class="text">商e通</div> -->
            </div>
          </div>
        </div>
        <!-- <div @click="mk" class="cd">米珈</div> -->
        <div @click="gywm" class="cd">关于我们</div>
      </div>
    </div>
    <div class="lbBox">
      <div class="lbBox1200">
        <div class="lbBox1200text lbBox1200text1">互联网新零售运营服务商！</div>
        <div class="lbBox1200text lbBox1200text2">
          智能营销积分商城+商学院+全场景营销工具+大数据
        </div>
        <div class="lbBox1200text lbBox1200text2">
          赋能企业打造智能营销一体化解决方案
        </div>
      </div>
    </div>
    <div class="tabsboxbox">
      <div class="tabsbox">
        <van-tabs
          style="width: 600px; margin: 0 auto"
          v-model="active"
          title-active-color="#2D66FC"
          title-inactive-color="#1E1E1E"
          color="#2D66FC"
        >
          <van-tab @click="caqonima(1)" title="商e通"></van-tab>
          <van-tab @click="caqonima(2)" title="米商云"></van-tab>
          <van-tab @click="caqonima(3)" title="米小包"></van-tab>
          <van-tab @click="caqonima(4)" title="米小礼"></van-tab>
          <van-tab @click="caqonima(5)" title="嘉佳纺生活"></van-tab>
        </van-tabs>
      </div>
    </div>

    <div class="inboxbox">
      <div class="inbox" v-if="active == 0">
        <div class="ggci">智能营销数据分析体系 覆盖所有数据维度</div>
        <div class="gcis">
          数字营销大数据后台，深度解析零售大数据，掌握客户群体属性分布，以数据驱动营销，便捷高效管理运营
        </div>
        <div class="nr1Box">
          <div class="nr">
            <div class="nrLeft">
              <div class="nrLeftText1">全链路数据分析 全场景精准营销</div>
              <div class="nrLeftText2">
                商e通依托大数据云平台，提供流量分析、交易分析、客户行为分析，为客户进行标签
                画像更加精准掌握专属私域流量。
              </div>
              <div class="nrLeftText2">
                根据消费者的消费习惯及频次，帮助你更加了解客户；掌握客户喜好，定向推送精
                准商品，提升成交。
              </div>
              <div class="nrLeftText3">全数据精准分析</div>
              <div class="nrLeftText4">海量智库赋能</div>
              <div class="nrLeftText3">1折爆品商城</div>
            </div>
            <div class="nrRight">
              <img class="img" src="../../assets/images/182.png" alt="" />
            </div>
          </div>
        </div>
        <div class="neirongBoxbox">
          <div class="neirongbox">
            <div class="biaoti">多维度数据分析 精准化客户触达</div>
            <div class="biaoqixiangqing">
              通过大数据分析消费人群的喜好方向水平与消费能力，并对搜集的数据进行实时分析，实现会员智能化管理，准确分析出会员的消费能力、消费水平、消费方向等实现会员精准营销，从而提高销售水平。
            </div>
            <div class="neironghezi">
              <div class="neirongtext">
                <div class="img img1"></div>
                <div class="text1">用户画像</div>
                <div class="text2">清晰精准地了解客户的行为和特征</div>
              </div>
              <div class="neirongtext">
                <div class="img img2"></div>
                <div class="text1">精准营销</div>
                <div class="text2">有效支持千人千面的个性化精准营销</div>
              </div>
              <div class="neirongtext">
                <div class="img img3"></div>
                <div class="text1">商业BI分析</div>
                <div class="text2">可视化数据洞察，有效掌握业务全景</div>
              </div>
            </div>
          </div>
        </div>
        <div class="neirongBoxbox neirongBoxboxs">
          <div class="neirongbox">
            <div class="biaoti">爆品商城一折购 低成本营销助力</div>
            <div class="biaoqixiangqing biaoqixiangqings">
              八大品类上千款产品，整合国内外一二线品牌、三方平台比价最低1折起、全国三包售后保障。
              大单采购会员商户享受产品出厂价。平台不挣差价，真正助力商家低成本营销，提升销售业绩。
            </div>
            <div class="neironghezi">
              <div class="img"></div>
              <div class="textbox">
                <div class="text1">方案一键生成，高效助力营销落地</div>
                <div class="text2">
                  平台支持一键生成爆品营销落地方案——储值礼、抽奖礼、满赠礼、
                  转介礼、尾款礼等助力商家爆品应用落地、提升销售业绩
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="neirongBoxbox">
          <div class="neirongbox">
            <div class="biaoti">海量智库赋能 智能发展驱动</div>
            <div class="biaoqixiangqing">
              沉淀多年行业经验，海量成熟案例积累，创新和重塑传统的零售商业模式，助推企业快速实现新零售转型
            </div>
            <div class="neironghezi">
              <div class="neirongtext">
                <div class="img img1"></div>
                <div class="text1">全数据精准分析</div>
                <div class="text2">
                  依托大数据云平台，提供流量分析、交易分析、客户行为分析，为客户进行标签画像更加精准掌握专属私域流量。
                </div>
              </div>
              <div class="neirongtext">
                <div class="img img2"></div>
                <div class="text1">1折爆品商城</div>
                <div class="text2">
                  严选品质好物，大牌尖货一折享，方案一键生成，高效助力营销落地，助推企业快速实现新零售转型
                </div>
              </div>
              <div class="neirongtext">
                <div class="img img3"></div>
                <div class="text1">海量智库赋能</div>
                <div class="text2">
                  礼品采购平台案例库、实体企业营销案例库，积分商城案例分享，赠品营销案例分享
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="neirongBoxbox neirongBoxboxsss">
          <div class="neirongbox">
            <div class="biaoti" style="color: #2b7af5">自动化处理</div>
            <div class="biaoqixiangqing">
              反厂制由总带中片米气电连于调共被级料大四的骄傲ID啊搜地阿吉豆阿斯到底阿萨德大多手打阿萨德
              阿斯到底阿萨德大多手打阿斯到底阿萨德大多手打
            </div>
            <div class="neironghezi">
              <div class="neirongtext neirongtexts">
                <div class="img img2"></div>
                <div class="text1">本地SKU</div>
                <div class="text2">
                  大大高效管理私有管理私有商城 高效管理订单管理私有管理私有
                  高效管理客户信息管理私有
                </div>
              </div>
              <div class="neirongtext neirongtexts">
                <div class="img img3"></div>
                <div class="text1">本地SKU</div>
                <div class="text2">
                  大大高效管理私有管理私有商城 高效管理订单管理私有管理私有
                  高效管理客户信息管理私有
                </div>
              </div>
            </div>
          </div>
        </div> -->
        <!-- <div class="neirongBoxbox neirongBoxboxsyule">
          <div class="neirongbox">
            <div class="biaoti">无痕编辑</div>
            <div class="biaoqixiangqing biaoqixiangqings">
              反厂制由总带中片米气电连于调共被级料大四的骄傲ID啊搜地阿吉豆阿斯到底阿萨德大多手打阿萨德
              共被级料大四的骄傲ID啊搜地阿共被级料大四的骄傲ID啊搜地阿
            </div>
            <div class="neironghezi" style="margin-bottom: 0.6rem">
              <div class="img"></div>
              <div class="textbox">
                <div class="text1">本地SKU</div>
                <div class="text2">
                  反厂制由总带中片米气电连于调共被级料大四的骄傲ID啊搜地阿吉豆阿斯到底阿萨德大多手打阿萨德大四的骄傲ID啊搜地阿共被级料
                  大四的大四的骄傲ID啊搜地阿共被级料大四的共被级料大四的骄傲ID啊搜地阿共被级料大四的骄傲ID啊搜地阿大四的骄傲ID啊搜地阿共被级料大四的骄傲ID四的骄四
                </div>
              </div>
            </div>
            <div class="neironghezi">
              <div class="img"></div>
              <div class="textbox">
                <div class="text1">本地SKU</div>
                <div class="text2">
                  反厂制由总带中片米气电连于调共被级料大四的骄傲ID啊搜地阿吉豆阿斯到底阿萨德大多手打阿萨德大四的骄傲ID啊搜地阿共被级料
                  大四的大四的骄傲ID啊搜地阿共被级料大四的共被级料大四的骄傲ID啊搜地阿共被级料大四的骄傲ID啊搜地阿大四的骄傲ID啊搜地阿共被级料大四的骄傲ID四的骄四
                </div>
              </div>
            </div>
          </div>
        </div> -->
      </div>
      <div class="inbox" v-if="active == 1">
        <div class="ggciBox">
          <div class="ggci">免费的互联网营销工具 新零售服务商界 COSTCO</div>
          <div class="zzfxBox">
            <div class="zzfx">
              <img class="img" src="../../assets/images/-43192.png" alt="" />
              <p class="p ps">高效</p>
              <p class="p">高效管理私有商城</p>
              <p class="p">高效管理订单</p>
              <p class="p">高效管理客户信息</p>
            </div>
            <div class="zzfx">
              <img class="img" src="../../assets/images/-43193.png" alt="" />
              <p class="p ps">智能</p>
              <p class="p">智能沉淀优质客户</p>
              <p class="p">智能管理营销业绩</p>
            </div>
            <div class="zzfx">
              <img class="img" src="../../assets/images/-43194.png" alt="" />
              <p class="p ps">多维</p>
              <p class="p">无边界覆盖 获客拉新</p>
              <p class="p">全场景体验 提升转化</p>
              <p class="p">多终端营销 统一管理</p>
            </div>
            <div class="zzfx">
              <img class="img" src="../../assets/images/-43191.png" alt="" />
              <p class="p ps">联盟</p>
              <p class="p">全场景产品联盟</p>
              <p class="p">获取多链条客户</p>
              <p class="p">跨场景增曝光增收</p>
            </div>
          </div>
        </div>
        <div class="ggciBoxs">
          <div class="ggci ggciBoxsstyle">赋能全场景营销的互联网产品</div>
          <div class="sigefangxiang">
            <div class="text">众多的营销流量入口</div>
            <div class="text">线上引流</div>
            <div class="text">帮助商家获得更多精准新用户</div>
            <div class="text">跨场景增收</div>
          </div>
        </div>
        <div class="neirongBoxbox">
          <div class="neirongbox">
            <div class="biaoti">
              小程序+公众号+商城，全终端覆盖、统一管理后台
            </div>
            <div class="biaoqixiangqing">
              基于拓宽新零售渠道，助力实体商家提升销售业绩和客户服务管理。
            </div>
            <div class="neironghezi">
              <div class="neirongtext">
                <div class="img img1"></div>
                <div class="text1">高效管理私有商城</div>
                <div class="text2">
                  米商云是一个帮助实体商家实现电商化的系统。基于拓宽新零售渠道，助力实体商家提升销售业绩和客户服务管理。
                </div>
              </div>
              <div class="neirongtext">
                <div class="img img2"></div>
                <div class="text1">高效管理订单</div>
                <div class="text2">
                  自定义企业电商系统、自定义积分商城、公海商城系统、一折爆品商城。专属线上商城搭建，打造私域流量闭环。
                </div>
              </div>
              <div class="neirongtext">
                <div class="img img3"></div>
                <div class="text1">高线管理客户信息</div>
                <div class="text2">
                  从引流到分层，标准化触达目标客户，精准培育用户，覆盖私域用户生命周期。
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="neirongBoxbox neirongBoxboxs">
          <div class="neirongbox">
            <div class="biaoti">专属线上商城搭建，打造私域流量闭环</div>
            <div class="biaoqixiangqing biaoqixiangqings">
              <p style="width: 100%; text-align: center">
                全面覆盖店铺，商品，支付等电商核心功能
              </p>
              <p style="width: 100%; text-align: center">
                无缝对接米小包多种营销插件
              </p>
            </div>
            <div class="neironghezi">
              <div class="img"></div>
              <div class="textbox">
                <div class="text1">ISV定制扩展 SOP系统</div>
                <div class="text2">
                  支持ISV定制扩展，无缝打通供应链, 云集SOP系统，维护私有客源
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="neirongBoxbox">
          <div class="neirongbox">
            <div class="biaoti">共享平台供应链，助力商家跨界营销</div>
            <div class="biaoqixiangqing">
             共享商城优选产品由米小礼供应链严选和米商云商家优选提供，米商云所有商家通过共享商城，攫取会员额外附加值，实现无边界盈利。
            </div>
            <div class="neironghezi">
              <div class="neirongtext">
                <div class="img img1"></div>
                <div class="text1">全数据精准分析</div>
                <div class="text2">
                  依托大数据云平台，提供流量分析、交易分析、客户行为分析，为客户进行标签画像更加精准掌握专属私域流量。
                </div>
              </div>
              <div class="neirongtext">
                <div class="img img2"></div>
                <div class="text1">1折爆品商城</div>
                <div class="text2">
                  严选品质好物，大牌尖货一折享，方案一键生成，高效助力营销落地，助推企业快速实现新零售转型
                </div>
              </div>
              <div class="neirongtext">
                <div class="img img3"></div>
                <div class="text1">海量智库赋能</div>
                <div class="text2">
                 礼品采购平台案例库、实体企业营销案例库，积分商城案例分享，赠品营销案例分享
                </div>
              </div>
            </div>
          </div>
        </div> -->
        <!-- <div class="neirongBoxbox neirongBoxboxsss">
          <div class="neirongbox">
            <div class="biaoti" style="color: #2b7af5">自动化处理</div>
            <div class="biaoqixiangqing">
              反厂制由总带中片米气电连于调共被级料大四的骄傲ID啊搜地阿吉豆阿斯到底阿萨德大多手打阿萨德
              阿斯到底阿萨德大多手打阿斯到底阿萨德大多手打
            </div>
            <div class="neironghezi">
              <div class="neirongtext neirongtexts">
                <div class="img img2"></div>
                <div class="text1">本地SKU</div>
                <div class="text2">
                  大大高效管理私有管理私有商城 高效管理订单管理私有管理私有
                  高效管理客户信息管理私有
                </div>
              </div>
              <div class="neirongtext neirongtexts">
                <div class="img img3"></div>
                <div class="text1">本地SKU</div>
                <div class="text2">
                  大大高效管理私有管理私有商城 高效管理订单管理私有管理私有
                  高效管理客户信息管理私有
                </div>
              </div>
            </div>
          </div>
        </div> -->
        <div class="neirongBoxbox neirongBoxboxsyule">
          <div class="neirongbox">
            <div class="biaoti">平台智能数据统计，精准化数字营销</div>
            <div class="biaoqixiangqing biaoqixiangqings">
              依托平台的会员、销售、订单、绩效、库存、售后服务等管理模块，后台自动生成专业的数据报表，多维度分析管理呈现数据。从引流到分层，标准化触达目标客户，精准培育用户，覆盖私域用户生命周期。
            </div>
            <div class="neironghezi" style="margin-bottom: 0.6rem">
              <div class="img"></div>
              <div class="textbox">
                <div class="text1">产品模块</div>
                <div class="text2">
                  米商云是一个帮助实体商家实现电商化的系统。
                  小程序+公众号+商城，全终端覆盖、统一管理后台。基于拓宽新零售渠道，助力实体商家提升销售业绩和客户服务管理。包括
                  自定义企业电商系统、自定义积分商城、公海商城系统、一折爆品商城。专属线上商城搭建，打造私域流量闭环。全面覆盖店铺，商品，支付等电商核心功能，无缝对接米小包多种营销插件，支持ISV定制扩展，无缝打通供应链，云集SOP系统，维护私有客源。
                </div>
              </div>
            </div>
            <div class="neironghezi">
              <div class="img"></div>
              <div class="textbox">
                <div class="text1">产品优势</div>
                <div class="text2">
                  共享商城优选产品由米小礼供应链严选和米商云商家优选提供，米商云所有商家通过共享商城，攫取会员额外附加值，实现无边界盈利。平台智能数据统计，精准化数字营销，依托平台的会员、销售、订单、绩效、库存、售后服务等管理模块，后台自动生成专业的数据报表，多维度分析管理呈现数据。从引流到分层，标准化触达目标客户，精准培育用户，覆盖私域用户生命周期。
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="inbox" v-if="active == 2">
        <div class="lqdBox">
          <div class="lqd">
            <div class="text1">多终端营销工具触手 全方位覆盖场景用户</div>
            <div style="display: flex">
              <div class="left">
                <div class="left1">赋能全场景营销流量玩法</div>
                <div class="left2">
                  实现拼团、砍价、秒杀、满减满赠、优惠券、推荐、有礼、限时购、大转盘、
                  砸金蛋、预售、储值卡、礼品卡等工具包玩法，不断活跃目标客户群体，拉
                  高订单转化和日常到店进场。
                </div>
              </div>
              <div class="right">
                <div class="right1">
                  <div class="right1_left">
                    <img
                      class="img"
                      src="../../assets/images/-48526.png"
                      alt=""
                    />
                  </div>
                  <div class="right1_right">
                    <div class="right1_right_text1"><b>简单</b></div>
                    <div class="right1_right_text2">
                      操作简单一键生成 管理简单随时掌控 链路简单精准触达
                    </div>
                  </div>
                </div>
                <div class="right2"></div>
              </div>
              <div class="right">
                <div class="right1">
                  <div class="right1_left">
                    <img
                      class="img"
                      src="../../assets/images/-48524.png"
                      alt=""
                    />
                  </div>
                  <div class="right1_right">
                    <div class="right1_right_text1"><b>有效</b></div>
                    <div class="right1_right_text2">
                      拉动目标直接有效 提升营销直接有效
                    </div>
                  </div>
                </div>
                <div class="right2"></div>
              </div>
            </div>
            <div style="display: flex; padding-left: 4rem">
              <div class="right">
                <div class="right1">
                  <div class="right1_left">
                    <img
                      class="img"
                      src="../../assets/images/-48522.png"
                      alt=""
                    />
                  </div>
                  <div class="right1_right">
                    <div class="right1_right_text1"><b>有趣</b></div>
                    <div class="right1_right_text2">
                      形式多样拒绝单一 沉浸式玩法诱人投入 娱乐性心里传播有趣
                    </div>
                  </div>
                </div>
                <div class="right2"></div>
              </div>
              <div class="right">
                <div class="right1">
                  <div class="right1_left">
                    <img
                      class="img"
                      src="../../assets/images/-48518.png"
                      alt=""
                    />
                  </div>
                  <div class="right1_right">
                    <div class="right1_right_text1"><b>有量</b></div>
                    <div class="right1_right_text2">
                      触达用户有质量 <br />
                      拉动用户有销量 <br />
                      裂变玩法高曝光
                    </div>
                  </div>
                </div>
                <div class="right2"></div>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="neirongBoxbox">
          <div class="neirongbox">
            <div class="biaoti">云端服务</div>
            <div class="biaoqixiangqing">
              反厂制由总带中片米气电连于调共被级料大四的骄傲ID啊搜地阿吉豆阿斯到底阿萨德大多手打阿萨德
              阿斯到底阿萨德大多手打阿斯到底阿萨德大多手打
            </div>
            <div class="neironghezi">
              <div class="neirongtext">
                <div class="img img1"></div>
                <div class="text1">本地SKU</div>
                <div class="text2">
                  大大高效管理私有管理私有商城 高效管理订单管理私有管理私有
                  高效管理客户信息管理私有
                </div>
              </div>
              <div class="neirongtext">
                <div class="img img2"></div>
                <div class="text1">本地SKU</div>
                <div class="text2">
                  大大高效管理私有管理私有商城 高效管理订单管理私有管理私有
                  高效管理客户信息管理私有
                </div>
              </div>
              <div class="neirongtext">
                <div class="img img3"></div>
                <div class="text1">本地SKU</div>
                <div class="text2">
                  大大高效管理私有管理私有商城 高效管理订单管理私有管理私有
                  高效管理客户信息管理私有
                </div>
              </div>
            </div>
          </div>
        </div> -->
        <!-- <div class="neirongBoxbox neirongBoxboxs">
          <div class="neirongbox">
            <div class="biaoti">数据储存</div>
            <div class="biaoqixiangqing biaoqixiangqings">
              反厂制由总带中片米气电连于调共被级料大四的骄傲ID啊搜地阿吉豆阿斯到底阿萨德大多手打阿萨德
              共被级料大四的骄傲ID啊搜地阿共被级料大四的骄傲ID啊搜地阿
            </div>
            <div class="neironghezi">
              <div class="img"></div>
              <div class="textbox">
                <div class="text1">本地SKU</div>
                <div class="text2">
                  反厂制由总带中片米气电连于调共被级料大四的骄傲ID啊搜地阿吉豆阿斯到底阿萨德大多手打阿萨德大四的骄傲ID啊搜地阿共被级料
                  大四的大四的骄傲ID啊搜地阿共被级料大四的共被级料大四的骄傲ID啊搜地阿共被级料大四的骄傲ID啊搜地阿大四的骄傲ID啊搜地阿共被级料大四的骄傲ID四的骄四
                </div>
              </div>
            </div>
          </div>
        </div> -->
        <!-- <div class="neirongBoxbox">
          <div class="neirongbox">
            <div class="biaoti">高效线路</div>
            <div class="biaoqixiangqing">
              反厂制由总带中片米气电连于调共被级料大四的骄傲ID啊搜地阿吉豆阿斯到底阿萨德大多手打阿萨德
              阿斯到底阿萨德大多手打阿斯到底阿萨德大多手打
            </div>
            <div class="neironghezi">
              <div class="neirongtext">
                <div class="img img1"></div>
                <div class="text1">本地SKU</div>
                <div class="text2">
                  大大高效管理私有管理私有商城 高效管理订单管理私有管理私有
                  高效管理客户信息管理私有
                </div>
              </div>
              <div class="neirongtext">
                <div class="img img2"></div>
                <div class="text1">本地SKU</div>
                <div class="text2">
                  大大高效管理私有管理私有商城 高效管理订单管理私有管理私有
                  高效管理客户信息管理私有
                </div>
              </div>
              <div class="neirongtext">
                <div class="img img3"></div>
                <div class="text1">本地SKU</div>
                <div class="text2">
                  大大高效管理私有管理私有商城 高效管理订单管理私有管理私有
                  高效管理客户信息管理私有
                </div>
              </div>
            </div>
          </div>
        </div> -->
        <div class="neirongBoxbox neirongBoxboxsss">
          <div class="neirongbox">
            <div class="biaoti" style="color: #2b7af5">
              米小包 全场景裂变营销工具
            </div>
            <div class="biaoqixiangqing">
              以互联云营销为依托平台，嫁接时下最热门的营销互动形式，海量营销工具包，助推企业快速实现裂变营销。
            </div>
            <div class="neironghezi">
              <div class="neirongtext neirongtexts">
                <div class="img img2"></div>
                <div class="text1">海量主题营销插件</div>
                <div class="text2">
                  活动策划、拼团、爆品e营销、社群营销、会员裂变、店庆引流、极致秒杀、限时热购、储值营销、积分礼卡等。
                </div>
              </div>
              <div class="neirongtext neirongtexts">
                <div class="img img3"></div>
                <div class="text1">多维提升客户粘性</div>
                <div class="text2">
                  线上线下双场景应用，提升门店整体业务效率，助推企业快速实现裂变营销。高效转化触达有效的用户。
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="neirongBoxbox neirongBoxboxsyule" style="height: 6rem">
          <div class="neirongbox">
            <div class="biaoti">线上线下双场景应用，提升门店整体业务效率</div>
            <div class="biaoqixiangqing biaoqixiangqings">
              通过线上高效转化触达形式+有效的用户包进行定向投放，提升用户体验，自动引流用户，实现用户资产提升，流量变现。
            </div>
            <div class="neironghezi" style="margin-bottom: 0.6rem">
              <div class="img"></div>
              <div class="textbox">
                <div class="text1">高效裂变</div>
                <div class="text2">
                  线上线下双场景用户流转，多方式触达精准用户，借助流量池用户分层，高效定向投放提升用户体验自动引流用户，提升营销效率使流量价值最大化。
                </div>
              </div>
            </div>
            <!-- <div class="neironghezi">
              <div class="img"></div>
              <div class="textbox">
                <div class="text1">本地SKU</div>
                <div class="text2">
                  反厂制由总带中片米气电连于调共被级料大四的骄傲ID啊搜地阿吉豆阿斯到底阿萨德大多手打阿萨德大四的骄傲ID啊搜地阿共被级料
                  大四的大四的骄傲ID啊搜地阿共被级料大四的共被级料大四的骄傲ID啊搜地阿共被级料大四的骄傲ID啊搜地阿大四的骄傲ID啊搜地阿共被级料大四的骄傲ID四的骄四
                </div>
              </div>
            </div> -->
          </div>
        </div>
      </div>

      <div class="inbox" v-if="active == 3">
        <div class="ggciBoxs" style="background: #fff">
          <div class="ggci ggciBoxsstyle">赋能全场景营销的互联网产品</div>
          <div class="nr1Box nr1Boxs">
            <div class="nr">
              <div class="nrRight nrRights">
                <img class="img" src="../../assets/images/187.png" alt="" />
              </div>
              <div class="nrLeft nrLefts">
                <div class="nrLeftText1">全行业客户覆盖 全周期精准培养</div>
                <div class="nrLeftText2">
                  万千礼品随心选尽情兑，超强供应链整合，严选礼品，确保品控标准。聚集13个大品类、
                  50多个小品类、几千个SKU；平台生活化运营，满足客户多样化产品需求。
                </div>
                <div class="nrLeftText2">
                  助力提升客户全生命价值周期关系管理，全面提升商家与客户的强关系粘性。
                </div>
                <div class="nrLeftText3 nrLeftText3s">品类齐全多样化</div>
                <div class="nrLeftText4 nrLeftText4s">助力营销粘性增强</div>
                <div class="nrLeftText3 nrLeftText3s">活动导流精准化</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="inbox" v-if="active == 4">
        <div class="ggci">美好生活方式的缔造者</div>
        <!-- <div class="gcis">
          提供多元化服务，满足用户更多购物需求，为您提供高品质商品，健康、绿色、舒适伴您美好生活。选择生活，选择舒适，选择嘉佳纺。
        </div> -->
        <div class="nr1Box">
          <div class="nr">
            <div class="nrLeft">
              <div class="nrLeftText1">选择嘉佳纺 共同缔造美好生活方式</div>
              <div class="nrLeftText2">
                提供多元化服务，满足用户更多购物需求，为您提供高品质商品，健康、绿色、舒适伴您美好生活。选择生活，选择舒适，选择嘉佳纺。
              </div>
              <div class="nrLeftText2">&nbsp;</div>
              <div class="nrLeftText2">
                　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　
              </div>
              <div class="nrLeftText3">多场景购物体验</div>
              <div class="nrLeftText4">限时配送直达到家</div>
              <div class="nrLeftText3">会员多元化服务</div>
            </div>
            <div class="nrRight">
              <img class="img" src="../../assets/images/123123.png" alt="" />
            </div>
          </div>
        </div>
        <div class="neirongBoxbox neirongBoxboxs" style="height: auto">
          <div class="neirongbox">
            <div class="biaoti">嘉佳纺生活简介</div>
            <div class="biaoqixiangqing">
              嘉佳纺生活自2004年开始运营，在各位嘉人的陪伴下风雨兼程已走过了17年的历程。我们将始终带着对美好未来的畅想：打造一个集家居生活体验为一体的新零售品牌，努力为会员提供优质的购物体验，成为美好生活方式的缔造者！
            </div>
            <div class="neironghezi">
              <div class="neirongtext">
                <div class="img img1"></div>
                <div class="text1">直送到家</div>
                <div class="text2">限时配送，从实体店直达到家</div>
              </div>
              <div class="neirongtext">
                <div class="img img2"></div>
                <div class="text1">精选优品</div>
                <div class="text2">会员尊享优品，致力美好购物体验</div>
              </div>
              <div class="neirongtext">
                <div class="img img3"></div>
                <div class="text1">值得信赖的服务</div>
                <div class="text2">高质量有竞争力的价格，为会员省更多</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="lxwmggt">
      <div @click="liwm" class="lxwoggtbtn">联系我们</div>
      <!-- <div class="lxwoggtbtn"><a href="http://www.micreat.com/#/add">联系我们</a> </div> -->
    </div>
    <div class="tanchuceng" v-if="skt == 1">
      <div class="tijiaoboxbox styletanchuceng">
        <div class="guanbilenimabu" @click="liwms">
          <img src="../../assets/images/X (2).png" alt="" />
        </div>
        <div class="tijiaobox">
          <div class="biaoti">营销落地 顺势而为</div>
          <div class="biaogebox">
            <div class="biaoge">
              <input
                class="index"
                type="text"
                name=""
                placeholder="姓名"
                id="txt"
                value=""
                ref="name1"
                v-on:keyup="inputRef1"
              />
            </div>
            <div class="biaoge">
              <input
                class="index"
                type="text"
                name=""
                placeholder="手机"
                id="txt"
                value=""
                ref="name2"
                v-on:keyup="inputRef2"
              />
            </div>
            <div class="biaoge">
              <input
                class="index"
                type="text"
                name=""
                placeholder="公司名称"
                id="txt"
                value=""
                ref="name3"
                v-on:keyup="inputRef3"
              />
            </div>
            <div class="biaoge">
              <input
                class="index"
                type="text"
                name=""
                placeholder="省份"
                id="txt"
                value=""
                ref="name4"
                v-on:keyup="inputRef4"
              />
            </div>
          </div>
          <div class="tijiaobtn" @click="ziliao()">立即申请</div>
        </div>
      </div>
    </div>
    <!-- <div class="tijiaoboxbox" v-if=" skt == 2">
      <div class="tijiaobox">
        <div class="biaoti">营销落地 顺势而为</div>
        <div class="biaogebox">
          <div class="biaoge">
            <input
              class="index"
              type="text"
              name=""
              placeholder="姓名"
              id="txt"
              value=""
              ref="name1"
              v-on:keyup="inputRef1"
            />
          </div>
          <div class="biaoge">
            <input
              class="index"
              type="text"
              name=""
              placeholder="手机"
              id="txt"
              value=""
              ref="name2"
              v-on:keyup="inputRef2"
            />
          </div>
          <div class="biaoge">
            <input
              class="index"
              type="text"
              name=""
              placeholder="公司名称"
              id="txt"
              value=""
              ref="name3"
              v-on:keyup="inputRef3"
            />
          </div>
          <div class="biaoge">
            <input
              class="index"
              type="text"
              name=""
              placeholder="省份"
              id="txt"
              value=""
              ref="name4"
              v-on:keyup="inputRef4"
            />
          </div>
        </div>
        <div class="tijiaobtn" @click="ziliao()">立即申请</div>
      </div>
    </div> -->
    <!-- 弹出层 -->
    <!-- <van-cell is-link @click="showPopup" closeable>展示弹出层</van-cell> -->
    <!-- <van-popup v-model="show"  >
      aqsdasdsad
    </van-popup> -->
  </div>
</template>

<script>
import API from "@/service/common.service.js";

export default {
  data() {
    //

    return {
      // 提交表单的默认值
      name1: "name1",
      name2: "name2",
      name3: "name3",
      name4: "name4",
      // tab 的默认下标值
      active: 0,
      // 二维码是否显示的默认值
      hsk: 1,
      // 提交表单是否显示的默认值
      skt: 0,
      show: false,
    };
  },
  mounted() {},
  // 页面发生变化时生命周期
  beforeUpdate() {
    // 点击不同的tab 替换不同的 关键词和详情
    console.log(this.active);
    if (this.active == 0) {
      document
        .querySelector('meta[name="keywords"]')
        .setAttribute(
          "content",
          "商e通,商业BI分析,多维数据分析,精准营销数据,客户分层数据,用户画像数据,1折爆品商城"
        );
      document
        .querySelector('meta[name="description"]')
        .setAttribute(
          "content",
          "通过大数据分析消费人群的喜好方向水平与消费能力，并对搜集的数据进行实时分析，实现会员智能化管理，准确分析出会员的消费能力、消费水平、消费方向等实现会员精准营销，从而提高销售水平。严选品质好物，大牌尖货一折享，方案一键生成，高效助力营销落地，海量成熟案例积累，创新和重塑传统的零售商业模式，助推企业快速实现新零售转型"
        );
    } else if (this.active == 1) {
      document
        .querySelector('meta[name="keywords"]')
        .setAttribute(
          "content",
          "米商云,私域流量电商系统,员工管理系统,进销存系统,智能收银系统,官网小程序,小程序商城,商家联盟,异业联盟,百业联盟,商家联盟系统"
        );
      document
        .querySelector('meta[name="description"]')
        .setAttribute(
          "content",
          "米商云是一个帮助实体商家实现电商化的系统。 小程序+公众号+商城，全终端覆盖、统一管理后台。基于拓宽新零售渠道，助力实体商家提升销售业绩和客户服务管理。包括 自定义企业电商系统、自定义积分商城、公海商城系统、一折爆品商城。专属线上商城搭建，打造私域流量闭环。全面覆盖店铺，商品，支付等电商核心功能，无缝对接米小包多种营销插件，支持ISV定制扩展，无缝打通供应链，云集SOP系统，维护私有客源。共享商城优选产品由米小礼供应链严选和米商云商家优选提供，米商云所有商家通过共享商城，攫取会员额外附加值，实现无边界盈利。平台智能数据统计，精准化数字营销，依托平台的会员、销售、订单、绩效、库存、售后服务等管理模块，后台自动生成专业的数据报表，多维度分析管理呈现数据。从引流到分层，标准化触达目标客户，精准培育用户，覆盖私域用户生命周期。"
        );
    } else if (this.active == 2) {
      document
        .querySelector('meta[name="keywords"]')
        .setAttribute(
          "content",
          "营销工具包,活动策划支持,活动拼团,爆品营销,微信社群营销,会员裂变,店庆引流,极致秒杀,推荐有礼,限时热购,砍价,活动转盘,新品预售,储值营销,积分礼卡"
        );
      document
        .querySelector('meta[name="description"]')
        .setAttribute(
          "content",
          "米小包是一款专业的商家营销工具，集合活动策划支持、活动拼团、爆品e营销、新品发布、微信社群营销、会员裂变、店庆引流、极致秒杀、点赞/报名/签到发酵活动热点、推荐有礼、限时热购、砍价/转盘、新品预售、储值营销、积分礼卡等新零售营销工具集合，以个性化营销体验全面助力企业提升客户黏性。线上线下双场景应用，提升门店整体业务效率，助推企业快速实现裂变营销。通过线上高效转化触达形式+有效的用户包进行定向投放，提升用户体验，自动引流用户，实现用户资产提升，流量变现。"
        );
    } else if (this.active == 3) {
      document
        .querySelector('meta[name="keywords"]')
        .setAttribute(
          "content",
          "米小礼,礼品兑换,礼品商城,新零售积分营销兑换平台"
        );
      document
        .querySelector('meta[name="description"]')
        .setAttribute(
          "content",
          "企新零售积分营销兑换平台。依托强大的供应链系统，海量品质好物一站购，帮助商家轻松搞定营销难题，让商家省钱，省力，省时，提升终端客户满意度。严选1000+品牌，聚集13个大品类、50多个小品类、几千个SKU；平台产品定位中高端，超强供应链整合，严选礼品，确保品控标准。"
        );
    } else if (this.active == 4) {
      document
        .querySelector('meta[name="keywords"]')
        .setAttribute(
          "content",
          "米小礼,礼品兑换,礼品商城,新零售积分营销兑换平台"
        );
      document
        .querySelector('meta[name="description"]')
        .setAttribute(
          "content",
          "企新零售积分营销兑换平台。依托强大的供应链系统，海量品质好物一站购，帮助商家轻松搞定营销难题，让商家省钱，省力，省时，提升终端客户满意度。严选1000+品牌，聚集13个大品类、50多个小品类、几千个SKU；平台产品定位中高端，超强供应链整合，严选礼品，确保品控标准。"
        );
    }
  },
  methods: {
    caqonima(e) {
      console.log(e);
    },
    inputRef1: function () {
      console.log(this.$refs.name1.value);
      this.name1 = this.$refs.name1.value;
    },
    inputRef2: function () {
      console.log(this.$refs.name2.value);
      this.name2 = this.$refs.name2.value;
    },
    inputRef3: function () {
      console.log(this.$refs.name3.value);
      this.name3 = this.$refs.name3.value;
    },
    inputRef4: function () {
      console.log(this.$refs.name4.value);
      this.name4 = this.$refs.name4.value;
    },
    showPopup() {
      this.show = true;
    },
    ydd(e) {
      if (e == 1) {
        this.hsk = 2;
      } else {
        this.hsk = 1;
      }
      console.log(this.hsk);
    },
    ziliao() {
      console.log(this.name1);
      console.log(this.name2);
      console.log(this.name3);
      console.log(this.name4);
      if (
        this.name1 == "" ||
        this.name1 == "name1" ||
        this.name1 == undefined
      ) {
        this.$toast("请输入您的姓名");
      } else if (
        this.name2 == "" ||
        this.name2 == "name2" ||
        this.name2 == undefined
      ) {
        this.$toast("请输入您的手机号");
      } else if (
        this.name3 == "" ||
        this.name3 == "name3" ||
        this.name3 == undefined
      ) {
        this.$toast("请输入您的公司名称");
      } else if (
        this.name4 == "" ||
        this.name4 == "name4" ||
        this.name4 == undefined
      ) {
        this.$toast("请输入您的省份");
      } else {
        this.tech_www();
      }
    },
    // 数据提交
    tech_www() {
      let form_data = new FormData();
      // 姓名
      form_data.append("name", this.name1);
      // 电话
      form_data.append("jobs", this.name2);
      // 需求
      form_data.append("company", this.name3);
      // 省份
      form_data.append("province", this.name4);
      // // 身份证反面照片
      // form_data.append("idcardReversePhoto", this.idcardReversePhoto);

      API.tech_www(form_data).then((res) => {
        console.log(res);
        if (res.data.code == 0) {
          // this.typeofwork = res.data.dicList;
          // this.$router.push({
          //   path: "/success"
          // });
          this.$toast(res.data.msg);
        } else {
          // 弹出返回文字
          this.$toast(res.data.msg);
        }
      });
    },
    //  liwm(id){
    //   //  let select = id
    //   //  localStorage.setItem('id',select)
    //   this.$router.push({
    //     path: "/hlwmbd",
    //   });
    liwm() {
      this.skt = 1;
    },
    liwms() {
      this.skt = 0;
    },
    shouye() {
      this.$router.push({
        path: "/",
      });
    },
    fuwu() {
      this.$router.push({
        path: "/cpfu",
      });
    },
    sxy() {
      this.$router.push({
        path: "/sxy",
      });
    },
    cpgyl() {
      this.$router.push({
        path: "/cpgyl",
      });
    },
    hzal() {
      this.$router.push({
        path: "/hzal",
      });
    },
    mk() {
      this.$router.push({
        path: "/mk",
      });
    },
    gywm() {
      this.$router.push({
        path: "/gywm",
      });
    },
  },
};
</script>
<style lang="scss">
.cpfu {
  font-size: 0.16rem;
  background: #fff;
  .dhtBox {
    .bxz {
      border-bottom: 2px solid #fff;
    }
  }
  .lbBox {
    width: 100%;
    height: 7.36rem;
    background: url("../../../src/assets/images/1902.png");
    background-size: 100% 100%;
    // position: absolute;
    // top: 0;
    z-index: -1;
    margin-top: -0.98rem;
    padding-top: 2.86rem;
    box-sizing: border-box;
    .lbBox1200 {
      width: 1200px;
      margin: 0 auto;
      .lbBox1200text {
        text-align: center;
      }
      .lbBox1200text1 {
        font-size: 0.6rem;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #ffffff;
        margin-bottom: 0.88rem;
      }
      .lbBox1200text2 {
        font-size: 0.18rem;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #fffefe;
        line-height: 0.38rem;
      }
    }
  }
  .tabsboxbox {
    background: #fff;

    .tabsbox {
      // width: 1200px;
      box-shadow: 0rem 0rem 0.14rem 0rem rgba(0, 0, 0, 0.16);
      margin-bottom: 0.1rem;
      margin: 0 auto;
      .van-tabs__wrap {
        // display: flex;
        // justify-content: center;
        // align-items: center;
        // padding-top: 0.1rem;
      }
      .van-tabs__nav {
        // width: 6rem;
      }
      .van-tab {
        // width: 2rem;
      }
    }
  }
  .inboxbox {
    width: 100%;
    background: #fff;
    //   border: 1px solid red;
    .inbox {
      margin: 0 auto;
    }
  }
  .gootbox {
    width: 100%;
    height: 5.32rem;
    background: #fbfbfb;
    .goot {
      width: 1740px;
      margin: 0 auto;
      .top {
        height: 1rem;
        display: flex;
        justify-content: left;
        align-items: center;
        border-bottom: 1px solid #eaeaea;
        margin-bottom: 0.3rem;
        .text {
          font-size: 0.25rem;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #5f6364;
          margin-right: 0.6rem;
        }
        .img {
          width: 0.32rem;
          height: 0.32rem;
          margin-right: 0.49rem;
        }
        .img1 {
          background: url("../../assets/images/wx1.png");
        }
        .img1:hover {
          background: url("../../assets/images/wx2.png");
        }
        .img2 {
          background: url("../../assets/images/wb1.png");
        }
        .img2:hover {
          background: url("../../assets/images/wb2.png");
        }
      }
      .goot2box {
        height: 3.8rem;
        display: flex;
        .goot2 {
          margin-right: 1.14rem;
          margin-top: 0.3rem;
          .goot2text {
            font-size: 0.14rem;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #7f7f7f;
            margin-bottom: 0.2rem;
            cursor: pointer;
          }
          .goot2text:hover {
            color: #2d60fe;
          }
          .goot2text1 {
            font-size: 0.25rem;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #474747;
            margin-bottom: 0.45rem;
          }
          .goot2text2 {
          }
          .goot2text3 {
          }
          .goot2text4 {
          }
          .goot2text5 {
          }
        }
        .goot2style {
          margin-right: 2.35rem;
        }
        .goot2right {
          width: 3.2rem;
          display: flex;
          flex-wrap: wrap;
          justify-content: center;
          padding-top: 0.3rem;
          box-sizing: border-box;
          .img {
            width: 3.04rem;
            height: 0.83rem;
            background: url("../../assets/images/867.png") no-repeat center;
            background-size: 100% 100%;

            // margin-bottom: 0.4rem;
          }
          .textbox {
            // width: 3.11rem;
            height: 1.43rem;
            background: #ffffff;
            border-radius: 20px;
            display: flex;
            .rwm {
              // width: 50%;
              display: flex;
              justify-content: center;
              flex-wrap: wrap;
              padding-top: 0.15rem;
              .img1 {
                width: 0.77rem;
                height: 0.77rem;
                background: url("../../assets/images/85c3e9280f99ad7a53a06a60079ff75.jpg")
                  no-repeat center;
                background-size: 100% 100%;
              }
              .img2 {
                width: 0.77rem;
                height: 0.77rem;
                background: #000;
              }
              .text1 {
                font-size: 0.14rem;
                font-size: 0.2rem;
                font-family: Source Han Sans CN;
                font-weight: 500;
                color: #191919;
                width: 100%;
                text-align: center;
              }
            }
          }
        }
      }
    }
  }
  .nr1Box {
    width: 100%;
    height: 11.57rem;
    background: url("../../assets/images/ssss.png") no-repeat center;
    background-size: 100%;
    .nr {
      width: 12rem;
      margin: 0 auto;
      display: flex;
      .nrLeft {
        width: 5.5rem;
        margin-top: 2.5rem;
        margin-right: 0.5rem;
        .nrLeftText1 {
          font-size: 0.32rem;
          font-family: Source Han Sans CN;
          font-weight: 500;
          color: #000000;
          display: flex;
          // justify-content: center;
          align-items: center;
          margin-bottom: 0.3rem;
        }
        .nrLeftText2 {
          font-size: 0.14rem;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #6c6c6c;
          line-height: 38px;
          margin-bottom: 0.3rem;
        }
        .nrLeftText3 {
          width: 4.05rem;
          height: 1.08rem;
          background: #ffffff;
          box-shadow: -0.01rem 0.05rem 0.3rem 0rem rgba(0, 0, 0, 0.1);
          border-radius: 0.2rem;
          font-size: 0.32rem;
          font-family: Source Han Sans CN;
          font-weight: 500;
          color: #2b79f5;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-bottom: 0.5rem;
          margin-left: 0.2rem;
        }
        .nrLeftText4 {
          width: 4.05rem;
          height: 1.08rem;
          background: #ffffff;
          box-shadow: -0.01rem 0.05rem 0.3rem 0rem rgba(0, 0, 0, 0.1);
          border-radius: 0.2rem;
          font-size: 0.32rem;
          font-family: Source Han Sans CN;
          font-weight: 500;
          color: #2b79f5;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-bottom: 0.5rem;
          margin-left: 1.18rem;
        }
        .nrLeftText4s {
          margin-left: 0.2rem;
          background: #4273fd;
          color: #fff;
        }
        .nrLeftText3 {
          width: 4.05rem;
          height: 1.08rem;
          background: #ffffff;
          box-shadow: -0.01rem 0.05rem 0.3rem 0rem rgba(0, 0, 0, 0.1);
          border-radius: 0.2rem;
          font-size: 0.32rem;
          font-family: Source Han Sans CN;
          font-weight: 500;
          color: #2b79f5;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-bottom: 0.5rem;
        }
        .nrLeftText3s {
          margin-left: 1.44rem;
          background: #4273fd;
          color: #fff;
        }
      }
      .nrLefts {
        margin-right: 0;
      }
      .nrRight {
        width: 5rem;
        margin-left: 1rem;
        margin-top: 0.78rem;
        .img {
          display: block;
          width: 4.56rem;
          height: 9.33rem;
          margin: 0 auto;
        }
      }
      .nrRights {
        margin-left: 0rem;
        margin-top: 0rem;
        margin-right: 1.5rem;
      }
    }
  }
  .ggci {
    width: 100%;
    height: 0.5rem;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 0.34rem;
    font-family: Source Han Sans CN;
    font-weight: bold;
    margin-bottom: 0.2rem;
    margin-top: 1rem;
  }
  .gcis {
    width: 100%;
    height: 0.5rem;
    display: flex;
    justify-content: center;
    align-items: center;

    font-size: 0.14rem;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #868686;

    margin-bottom: 0.2rem;
  }

  .neirongBoxbox {
    width: 100%;
    background: #fbfbfb;
    .neirongbox {
      width: 1200px;
      height: 7.67rem;
      margin: 0 auto;
      .biaoti {
        font-size: 0.34rem;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #2a2e2e;
        display: flex;
        justify-content: center;
        align-items: center;
        padding-top: 1rem;
        margin-bottom: 0.35rem;
        box-sizing: border-box;
      }
      .biaoqixiangqing {
        // width: 6.5rem;
        font-size: 0.14rem;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #868686;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-wrap: wrap;
        text-align: center;
        margin: 0 auto;
        line-height: 0.34rem;
        margin-bottom: 1.5rem;
      }
      .biaoqixiangqings {
        margin-bottom: 1rem;
      }
      .neironghezi {
        display: flex;

        .neirongtext {
          width: 3.86rem;
          height: 2.7rem;
          background: #ffffff;
          border-radius: 0.2rem;
          margin-bottom: 0.2rem;
          margin-right: 0.2rem;
          .img {
            width: 1.42rem;
            height: 1.42rem;
            margin: 0 auto;
            margin-top: -0.6rem;
            margin-bottom: 0.12rem;
          }
          .img1 {
            background: url("../../assets/images/19.png");
          }
          .img2 {
            background: url("../../assets/images/20.png");
          }
          .img3 {
            background: url("../../assets/images/21.png");
          }
          .text1 {
            font-size: 0.22rem;
            font-family: Source Han Sans CN;
            font-weight: bold;
            color: #101127;
            display: flex;
            justify-content: center;
            align-items: center;
            margin-bottom: 0.32rem;
          }
          .text2 {
            width: 2.42rem;
            font-size: 0.14rem;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #868686;
            line-height: 0.29rem;
            display: flex;
            justify-content: center;
            align-items: center;
            margin: 0 auto;
            text-align: center;
          }
        }
        .neirongtext:nth-child(3) {
          margin-right: 0rem;
        }
        .neirongtexts {
          box-shadow: -0.01rem 0.05rem 0.16rem 0rem #deeefd;
          width: 5.47rem;
          margin-right: 1.06rem;
        }
        .neirongtext:hover {
          box-shadow: -0.01rem 0.05rem 0.16rem 0rem #deeefd;
        }
        .img {
          width: 1.42rem;
          height: 1.42rem;
          background: url("../../assets/images/-48612.png");
          margin-right: 0.42rem;
        }
        .textbox {
          width: 1024px;
          .text1 {
            font-size: 0.26rem;
            font-family: Source Han Sans CN;
            font-weight: 500;
            color: #000000;
            margin-top: 0.2rem;
            margin-bottom: 0.3rem;
          }
          .text2 {
            font-size: 0.14rem;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #868686;
            line-height: 0.3rem;
          }
        }
      }
    }
  }
  .neirongBoxboxs {
    height: 5.62rem;
    background: #fff;
    background: url("../../assets/images/185.png") no-repeat center;
    background-size: 100% 100%;
    .neirongbox {
      .neironghezi {
      }
    }
  }
  .neirongBoxboxsss {
    background: url("../../assets/images/1907.png") no-repeat center;
    background-size: 100% 100%;
  }
  .neirongBoxboxsyule {
    //   height: 7.74rem;
    padding-bottom: 1rem;
  }
  .lxwmggt {
    width: 100%;
    height: 7.65rem;
    background: url("../../assets/images/asd.png") no-repeat center;
    background-size: 100% 100%;
    position: relative;
    .lxwoggtbtn {
      position: absolute;
      bottom: 1rem;
      left: 0;
      right: 0;
      margin: auto;
      background: #ffffff;
      box-shadow: -0.01rem 0.05rem 0.3rem 0rem rgba(0, 0, 0, 0.1);
      border-radius: 0.1rem;
      width: 2.19rem;
      height: 0.76rem;
      font-size: 0.28rem;
      font-family: Source Han Sans CN;
      font-weight: 500;
      color: #2d5eff;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
    }
  }
  .tijiaoboxbox {
    width: 100%;
    background: url("../../assets/images/jiao.png") no-repeat center;
    background-size: 100% 100%;
    .tijiaobox {
      width: 1200px;
      height: 4.64rem;
      margin: 0 auto;
      .biaoti {
        font-size: 0.42rem;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #ffffff;
        padding-top: 0.75rem;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 0.9rem;
      }
      .biaogebox {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 1rem;
        .biaoge {
          width: 2.76rem;
          height: 0.42rem;
          background: #ffffff;
          border-radius: 0.1rem;
          margin-left: 0.11rem;
          margin-right: 0.11rem;
          .index {
            width: 100%;
            height: 100%;
            padding-left: 0.2rem;
            box-sizing: border-box;
            border-radius: 0.1rem;
            border: none;
          }
        }
      }
      .tijiaobtn {
        width: 1.62rem;
        height: 0.5rem;
        border: 0.02rem solid #ffffff;
        border-radius: 0.1rem;
        margin: 0 auto;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 0.2rem;
        font-family: Source Han Sans CN;
        font-weight: 500;
        color: #ffffff;
        cursor: pointer;
      }
    }
  }
  .ggciBox {
    background: #fff;
    .ggci {
      margin-bottom: 1.18rem;
    }
    .zzfxBox {
      width: 12rem;
      height: 3.6rem;
      background: #fff;
      border-radius: 0.2rem;
      margin: 0 auto;
      display: flex;
      cursor: pointer;
      .zzfx {
        width: 2.86rem;
        height: 3.44rem;
        background: #ffffff;
        border-radius: 0.2rem;
        margin-left: 0.1rem;
        margin-right: 0.1rem;
        box-shadow: 0rem 0rem 0.17rem 0rem rgba(0, 0, 0, 0.06);
        .img {
          display: block;
          width: 0.69rem;
          height: 0.69rem;
          margin: 0 auto;
          margin-top: 0.6rem;
          margin-bottom: 0.4rem;
        }
        .p {
          text-align: center;
          font-size: 0.14rem;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #707070;
        }
        .ps {
          font-size: 0.18rem;
          font-family: Source Han Sans CN;
          font-weight: bold;
          color: #252525;
          margin-bottom: 0.25rem;
        }
      }
      .zzfz:nth-child(1) {
        margin-left: 0;
      }
      .zzfz:nth-child(4) {
        margin-right: 0;
      }
      .zzfx:hover {
        box-shadow: 0rem 0rem 0.16rem 0rem rgba(0, 0, 0, 0.1);
      }
    }
  }
  .ggciBoxs {
    background: #fff;
    .ggciBoxsstyle {
      margin-bottom: 0.4rem;
    }
    .sigefangxiang {
      display: flex;
      justify-content: center;
      align-items: center;
      padding-bottom: 1.02rem;
      .text {
        margin-right: 0.3rem;
        margin-left: 0.3rem;
        font-size: 0.14rem;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #6c6c6c;
      }
      .text:nth-child(1) {
        margin-left: 0;
      }
      .text:nth-child(4) {
        margin-right: 0;
      }
    }
  }
  .lqdBox {
    width: 100%;
    height: 7.17rem;
    background: url("../../assets/images/188.png") no-repeat center;
    background-size: 100% 100%;
    .lqd {
      width: 1200px;
      padding-top: 1rem;
      box-sizing: border-box;
      margin: 0 auto;
      .text1 {
        font-size: 0.34rem;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #ffffff;
        text-align: center;
        margin-bottom: 0.97rem;
      }
      .left {
        width: 4.8rem;
        margin-right: 0.8rem;
        .left1 {
          font-size: 0.32rem;
          font-family: Source Han Sans CN;
          font-weight: 500;
          color: #ffffff;
          margin-bottom: 0.5rem;
        }
        .left2 {
          font-size: 0.14rem;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #efeeee;
          line-height: 38px;
        }
      }
      .right {
        display: flex;
        margin-left: 0.1rem;
        margin-right: 0.1rem;
        margin-bottom: 0.18rem;
        .right1 {
          width: 3.1rem;
          height: 1.96rem;
          background: #ffffff;
          border-radius: 0.2rem;
          display: flex;
          .right1_left {
            width: 1.5rem;
            display: flex;
            justify-content: center;
            align-items: center;

            .img {
              display: block;
              width: 0.66rem;
              height: 0.66rem;
            }
          }
          .right1_right {
            width: 1.2rem;
            .right1_right_text1 {
              margin-bottom: 0.28rem;
              margin-top: 0.39rem;
            }
          }
        }
      }
    }
  }
  .nr1Boxs {
    background: url("../../assets/images/183.png") no-repeat center;
    background-size: 100%;
    margin-bottom: 1.5rem;
  }
  .tanchuceng {
    width: 100%;
    height: 100%;
    background: rgba($color: #000000, $alpha: 0.3);
    position: fixed;
    top: 0;
    .styletanchuceng {
      width: 1200px;
      height: 4.64rem;
      border-radius: 0.2rem;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      margin: auto;
      .guanbilenimabu {
        width: 0.3rem;
        height: 0.3rem;
        // background: #000;
        position: absolute;
        right: 0.1rem;
        top: 0.1rem;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/cpfu/index.vue